import { toast } from 'react-toastify'
import { useState, useRef } from 'react'
import { useAPI } from 'global'
import { apiError } from 'utils'
import Screen from './screen'

export default function ExternalDashboards() {
  const api = useAPI()
  const [data, setData] = useState()
  const filters = useRef()

  const refresh = () => {
    api.getExternalDashboards(filters.current).then(response => {
      setData(response)
    }).catch(apiError)
  }

  const selectExternalDashboard = externalDashboard => {
    api.getEmbedURL(externalDashboard.id).then(response => {
      const url = response?.embedUrl
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer')
      } else {
        toast.error('Error trying to open external dashboard URL')
      }
    }).catch(apiError)
  }

  return (
    <Screen
      data={data}
      onQuery={refresh}
      onSelect={selectExternalDashboard}
    />
  )
}